// Constants
import {
  PRICE_LIST_CREATE_PAGE_TITLE,
  PRICE_LIST_DETAIL_PAGE_TITLE,
  PRICE_LIST_EDIT_PAGE_TITLE,
} from "ui/components/PageTitle/consts";

// Types
import { PriceListInfoCardProps } from "./types";
import { PriceListDetailFormValues } from "services/api/prices/types";

// Services & API Calls
import { getPriceListAPI } from "services/api/prices/api";

// React and State Management
import { memo, useCallback, useEffect, useState } from "react";

// UI Components
import { Button } from "ui/components/Button/Button";
import { Modal } from "ui/components/Modal";
import ModalHeader from "ui/components/Modal/ModalHeader";
import ModalBody from "ui/components/Modal/ModalBody";
import { Loader } from "ui/components/Loader";

// Helpers
import { useTranslate } from "helpers";

// Constants/Initial Values
import { initialPriceListDetailForm } from "services/api/prices/consts";

// Validation
import { Errors } from "services/forms/validation/types";

// Custom Components
import PriceListEditCard from "../../../PriceListEditCard/PriceListEditCard";

const PriceListInfoCard: React.FC<PriceListInfoCardProps> = (props) => {
  const { priceListId } = props;

  const { t } = useTranslate();
  const [errors, setErrors] = useState<Errors>({});
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [showEditModal, setShowEditModal] = useState<boolean>(false);

  const [formValues, setFormValues] = useState<PriceListDetailFormValues>(
    initialPriceListDetailForm
  );

  useEffect(() => {
    if (priceListId) {
      fetchPriceList(priceListId);
    }
  }, [priceListId]);

  const fetchPriceList = async (id: string) => {
    if (id === undefined) {
      setFormValues(initialPriceListDetailForm);
      return;
    }

    setIsLoading(true);

    let result;
    try {
      result = await getPriceListAPI(id);
    } catch {
      setIsLoading(false);
      return;
    }

    setFormValues(result);
    setIsLoading(false);

    setErrors({});
  };

  const handleEditSuccess = useCallback(() => {
    if (priceListId) fetchPriceList(priceListId);
    setShowEditModal(false);
  }, []);

  if (!priceListId) return <></>;

  return (
    <>
      <div className="rounded-sm bg-white border max-w-lg w-full">
        <div className="divide-y divide-slate-200">
          <div className="flex justify-between items-center">
            <p className="text-sm font-semibold text-slate-600 px-4 py-3 uppercase">
              {t(PRICE_LIST_DETAIL_PAGE_TITLE.text)}
            </p>
            <div className="flex items-center gap-2 px-3 my-3 ">
              <Button
                size="small"
                variant="primary"
                children={t("admin.change")}
                onClick={() => setShowEditModal(true)}
                startIcon="/media/icons/plus.svg"
              />
            </div>
          </div>
          <div className="px-4 py-2 min-h-[56px]">
            <div className="text-xs font-medium uppercase text-slate-600">
              {t("admin.calculation.vehiclegroup.detail.name")}
            </div>
            <div className="text-sm text-slate-500 truncate">
              {/* {formValues.name} */}
            </div>
          </div>
         
        </div>
      </div>
      {showEditModal && (
        <Modal show={showEditModal} onHide={() => setShowEditModal(false)}>
          <ModalHeader
            title={
              priceListId
                ? PRICE_LIST_EDIT_PAGE_TITLE.text
                : PRICE_LIST_CREATE_PAGE_TITLE.text
            }
            onHide={() => setShowEditModal(false)}
          />
          <ModalBody>
            <PriceListEditCard
              priceListId={priceListId}
              onSuccess={handleEditSuccess}
            />
          </ModalBody>
        </Modal>
      )}
      <Loader isLoading={isLoading ?? false}> </Loader>
    </>
  );
};

export default memo(PriceListInfoCard);
